import { Card, Col, Divider, List, Row, Typography } from 'antd';
import { IconArrowDoubleRight } from '../BasicComponents/Icons';

const { Title, Paragraph, Text } = Typography;

const facts = [
  'Prediction can cover huge races with thousands of participants using no additional hardware.',
  'Setting up a prediction only takes 10s of minutes or even less.',
  'Prediction works best on races with steady velocities (e.g., city marathons).',
  'Quality depends on the number of readers.',
  'Prediction cannot detect cancellations.',
  'Prediction is always faulty – if you want real live tracking use App-Tracking or GPS-Tracking.',
  'Prediction is the only well-established live tracking solution for open water swimming.',
];

const dos = [
  'Check data transmission of reads before the race.',
  'The shadow track has to cover the whole unfolded race with high precision (especially on loops).',
  'Add as many readers as you have.',
  'If you have loops or crossings, use the readers there to increase the read count.',
  'Always use 2 readers with different readerIds at the start to trigger the first speed calculation.',
  'Always use a reader at the finish line.',
  'If you use a reader being a mat on an out and back section, cover the whole street out and back!',
  'Use prediction for races where the speed is steady.',
];

const donts = [
  'Do not just use a start and a finish reader.',
  'Do not put readers too far away from the track.',
  'Do not use a mat reader on only one side of the street in an out and back section – the algorithm will map both possible offsets.',
  'Do not use prediction when speed changes drastically at every reader location.',
];

const PredictionSetupGuide = () => {
  return (
    <div style={{ padding: '40px' }}>
      <Typography>
        <Title level={2}>Prediction Setup Guide</Title>
        <Paragraph>
          This guide helps you configure the prediction algorithm for races. The algorithm uses
          reads (Bib, time, geolocation) and maps them onto a shadow track to predict participant
          movement. Follow the best practices below for accurate predictions.
        </Paragraph>
      </Typography>

      {/* Diagram Section */}
      <Divider titlePlacement="start">How It Works</Divider>
      <Row justify="center" align="middle" gutter={16} style={{ marginBottom: '40px' }}>
        <Col>
          <Card variant="outlined" style={{ textAlign: 'center' }}>
            Reads
            <br />
            <small>(Bib, Time, Geo)</small>
          </Card>
        </Col>
        <Col>
          <IconArrowDoubleRight />
        </Col>
        <Col>
          <Card variant="outlined" style={{ textAlign: 'center' }}>
            Shadow Track
            <br />
            <small>(Unfolded Race)</small>
          </Card>
        </Col>
        <Col>
          <IconArrowDoubleRight />
        </Col>
        <Col>
          <Card variant="outlined" style={{ textAlign: 'center' }}>
            Offset Mapping
            <br />
            <small>(Relative Position)</small>
          </Card>
        </Col>
        <Col>
          <IconArrowDoubleRight />
        </Col>
        <Col>
          <Card variant="outlined" style={{ textAlign: 'center' }}>
            Prediction
            <br />
            <small>(Velocity & Live Tracking)</small>
          </Card>
        </Col>
      </Row>

      <Divider titlePlacement="start">Facts</Divider>
      <Row gutter={[16, 16]}>
        {facts.map((fact, idx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <Col xs={24} sm={12} key={idx}>
            <Card variant="outlined" hoverable>
              <Text strong style={{ fontSize: '16px' }}>
                {fact}
              </Text>
            </Card>
          </Col>
        ))}
      </Row>

      <Divider titlePlacement="start">Do's & Don'ts</Divider>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Card title="Do's" variant="outlined" hoverable style={{ marginBottom: '20px' }}>
            <List dataSource={dos} renderItem={(item) => <List.Item>✅ {item}</List.Item>} />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title="Don'ts" variant="outlined" hoverable>
            <List dataSource={donts} renderItem={(item) => <List.Item>❌ {item}</List.Item>} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PredictionSetupGuide;
